import { Pipe, PipeTransform } from '@angular/core';
import { Answer } from '../models/answer';

@Pipe({ name: 'filterListAnswers' })
export class FilterListAnswersPipe implements PipeTransform {
  transform(answerList: Answer[]): Answer[] {
    if (answerList && answerList.length) {
      return answerList.filter(
        (answer) => answer.answerttype !== 'OTHER_TEXTBOX' && answer.answerttype !== 'OTHER_TEXTBOX_REQUIRED'
      );
    }

    return [];
  }
}
